import { jwtDecode } from "jwt-decode";

export function isValidJwt(token) {
  try {
    jwtDecode(token);
    return true;
  } catch {
    return false;
  }
}